<script setup lang="ts">
import { computed, ref } from 'vue';
import { useDisplay } from 'vuetify';
import useLocale from '../helpers/use-locale';

type Emits = {
  (e: 'clickAdd'): void;
};
const emit = defineEmits<Emits>();

type Props = {
  label?: string;
};
defineProps<Props>();

const { t } = useLocale();
const { platform } = useDisplay();
const isLoading = ref(false);
const isTouchDevice = computed(() => platform.value.touch);
const handleClick = () => {
  isLoading.value = true;
  emit('clickAdd');
};
</script>

<template>
  <v-btn
    color="tertiary-container"
    size="x-small"
    icon
    :loading="isLoading"
    :aria-label="label"
    @click.stop.prevent="handleClick"
  >
    <v-icon>mdi-plus</v-icon>
    <v-tooltip
      :disabled="isTouchDevice"
      activator="parent"
      :text="t('components.add_button')"
      location="top"
      aria-hidden="true"
    />
  </v-btn>
</template>

<style scoped lang="scss"></style>
